import { render, staticRenderFns } from "./mGameResultInfo.vue?vue&type=template&id=55c34915"
import script from "./mGameResultInfo.vue?vue&type=script&lang=js"
export * from "./mGameResultInfo.vue?vue&type=script&lang=js"
import style0 from "./mGameResultInfo.vue?vue&type=style&index=0&id=55c34915&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports